import { checkGate, getLayer } from '@eventbrite/statsig';
import {
    InitialExperimentPostPaymentQuestionsVariant,
    INITIAL_EXPERIMENT_POST_PAYMENT_QUESTIONS,
    RecommendationsEnhancedExperimentVariant,
    RECOMMENDATIONS_ENHANCED_EXPERIMENT,
} from '../constants/statsig';

export const checkEnablePayPalLineItemsFeatureGate = () =>
    checkGate('checkout_enable_paypal_line_items');

export const checkRecommendationsEnhancedExperimentEnabled = () =>
    getLayer(
        RECOMMENDATIONS_ENHANCED_EXPERIMENT.layer,
        RECOMMENDATIONS_ENHANCED_EXPERIMENT.param,
        RECOMMENDATIONS_ENHANCED_EXPERIMENT.defaultValue,
    ) === RecommendationsEnhancedExperimentVariant.leftPaneFollowCard;

export const getInitialExperimentpostPaymentQuestionsValue =
    (): InitialExperimentPostPaymentQuestionsVariant =>
        getLayer<
            InitialExperimentPostPaymentQuestionsVariant,
            InitialExperimentPostPaymentQuestionsVariant
        >(
            INITIAL_EXPERIMENT_POST_PAYMENT_QUESTIONS.layer,
            INITIAL_EXPERIMENT_POST_PAYMENT_QUESTIONS.param,
            INITIAL_EXPERIMENT_POST_PAYMENT_QUESTIONS.defaultValue,
        );

export const isInitialExperimentPostPaymentQuestions = () =>
    getInitialExperimentpostPaymentQuestionsValue() !==
    InitialExperimentPostPaymentQuestionsVariant.oldDesign;
